/**
 * Preview toolbar layout by panel width (W2-02, W3-06 UX-051; DESIGN.md §4.8). Widths in CSS px of the panel. The
 * toolbar never takes more than one row, so the stage keeps its height in a narrow preview column:
 *  - wide (>= 820): every toggle is a button in the row (measured: about 790 px with the "Approximate" badge);
 *  - narrow (360-820): the default Chart preset at 1280 / 1366 / 1536 px (the preview gets about 384 / 406 / 461
 *    px) and the Laptop mini preview (420 px). The screen-shape button and the "Approximate" badge are icon-only,
 *    and the toggles (HUD, labels, ghosts, invisible lines, gizmo, auto-key, sample mode, lane link, readout,
 *    safe areas, snapping) sit in one "More preview options" popover, where each is still a one-click button and
 *    several can be switched without closing it. Phira settings, Theater and Test stay in the row;
 *  - compact (< 360): as narrow, and the Test button shows its icon only.
 */

export type ToolbarLayout = 'wide' | 'narrow' | 'compact';

/** From this panel width the whole toolbar fits one row with every toggle. */
export const WIDE_WIDTH = 820;
/** Below this panel width the Test button is icon-only. */
export const COMPACT_WIDTH = 360;

/** Toolbar layout of a panel width (0 or not finite = not measured yet: wide). */
export function toolbarLayoutFor(width: number): ToolbarLayout {
  if (!(width > 0) || !Number.isFinite(width) || width >= WIDE_WIDTH) return 'wide';
  return width < COMPACT_WIDTH ? 'compact' : 'narrow';
}
